/* ASC-CUSTOM (Atelier design demo, 2026-09-23): guide page helpers for sections/asc-at-article.liquid. No dependencies.
   - measures the theme's sticky header so the TOC and the side card stick just below it (--at-art-top)
   - builds the "In this guide" list from the article's h2/h3 (the short-answer box first; headings inside the older
     guide's own table of contents, the guest-count card and FAQ toggles are skipped; long guides list h2 only)
   - moves the reading bar and marks the section being read. Runs once; scroll work is batched per frame.
   - hides article images whose file is gone (404), so a missing picture never shows as a bare alt-text link. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-at-art]');
    if (!root) return;
    var toc = root.querySelector('[data-at-toc]'), list = root.querySelector('[data-at-toc-list]');
    var bar = root.querySelector('[data-at-toc-bar]'), scope = root.querySelector('[data-at-toc-scope]');
    var body = root.querySelector('.at-art__body');

    // the theme marks the header section sticky from its own script, so measure again after load and on resize
    function headerTop() {
      var h = document.querySelector('.header-section.sticky-header') || (document.querySelector('[data-header-sticky="true"]') && document.querySelector('.header-section'));
      var top = 24;
      if (h) top += Math.max(0, Math.round(h.getBoundingClientRect().height));
      root.style.setProperty('--at-art-top', top + 'px');
    }
    headerTop();
    window.addEventListener('load', headerTop);
    window.addEventListener('resize', headerTop, { passive: true });

    // an article image whose file no longer exists would show as a bare alt-text link: hide it (and its empty link)
    if (body) Array.prototype.forEach.call(body.querySelectorAll('img'), function (img) {
      function gone() { var a = img.closest('a'); img.hidden = true; if (a && !a.textContent.trim()) a.hidden = true; var f = img.closest('figure'); if (f && !f.querySelector('img:not([hidden])')) f.hidden = true; }
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src') && img.loading !== 'lazy') gone(); else img.addEventListener('error', gone);
    });

    if (!toc || !list || !body) return;
    var skip = 'nav, .asc-blog-toc, details, [data-at-toc-skip]';
    var all = Array.prototype.filter.call(body.querySelectorAll('h2, h3'), function (h) { return !h.closest(skip) && h.textContent.trim(); });
    var h2 = all.filter(function (h) { return h.tagName === 'H2'; });
    var heads = all.length > 9 && h2.length >= 3 ? h2 : all;
    var short = root.querySelector('#at-short');
    var items = [];
    if (short) items.push({ el: short, text: 'The short answer', sub: false });
    var used = {};
    heads.forEach(function (h) {
      if (!h.id) {
        var base = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
        var id = base, n = 2;
        while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
        h.id = id;
      }
      used[h.id] = true;
      items.push({ el: h, text: h.textContent.trim().replace(/\s+/g, ' '), sub: h.tagName === 'H3' && heads !== h2 });
    });
    if (items.length < 3) return;

    var links = items.map(function (it) {
      var li = document.createElement('li');
      if (it.sub) li.className = 'is-sub';
      var a = document.createElement('a');
      a.href = '#' + it.el.id;
      a.textContent = it.text;
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    root.classList.add('has-toc');

    var ticking = false, current = -1;
    function update() {
      ticking = false;
      if (toc.offsetParent === null) return;
      var vh = window.innerHeight;
      var r = scope.getBoundingClientRect();
      var total = Math.max(1, r.height - vh * 0.6);
      var p = Math.min(1, Math.max(0, (vh * 0.3 - r.top) / total));
      if (bar) bar.style.setProperty('--at-p', p.toFixed(3));
      var line = parseFloat(getComputedStyle(root).getPropertyValue('--at-art-top')) + 40;
      var on = 0;
      for (var i = 0; i < items.length; i++) { if (items[i].el.getBoundingClientRect().top - line <= 0) on = i; }
      if (on !== current) {
        if (current > -1) { links[current].classList.remove('is-on'); links[current].removeAttribute('aria-current'); }
        links[on].classList.add('is-on'); links[on].setAttribute('aria-current', 'location');
        current = on;
      }
    }
    function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
